/**
 * Upates the pageData object.
 */
export function updatePageData(eventName, data) {
    var _a;
    if (!window || !window.pageData || !eventName)
        return;
    const pageData = window.pageData;
    if (eventName === 'variantClicked') {
        const id = data;
        const variant = (_a = pageData.variants[id]) === null || _a === void 0 ? void 0 : _a.products[id];
        if (variant) {
            pageData.products = { [variant.id]: variant };
            window.pageData = pageData;
        }
    }
}
/**
 * Fires an adhoc tracking event.
 */
export function trackAdHocEvent(eventName = 'AdHocEvent', eventDetails = null) {
    if (eventName && window && window._satellite && window._satellite.track) {
        window._satellite.track(eventName, eventDetails);
    }
}
//# sourceMappingURL=track.js.map